class FooterController {
  constructor() {
    this.name = 'footer';
    this.currentYear = new Date().getFullYear();
  }
}

export default FooterController;



// WEBPACK FOOTER //
// ./client/app/common/footer/footer.controller.js